import {tagColors} from "@/components/tag/tag-colors"
export const AssemblyOrderEnum = {
  status: {
    DRAFT: 'draft',
    COMPLETED: 'completed',
    CANCEL: 'abolished',
  },
  statusOption: [
    {id: 'draft', text: '草稿', ...tagColors.blue},
    {id: 'completed', text: '已完成', ...tagColors.green},
    {id: 'abolished', text: '已作废', ...tagColors.lightGray},
  ]
};
